<!--
<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      For a guide and recipes on how to configure / customize this project,<br>
      check out the
      <a href="https://cli.vuejs.org" target="_blank" rel="noopener">vue-cli documentation</a>.
    </p>
    <h3>Installed CLI Plugins</h3>
    <ul>
      <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel" target="_blank" rel="noopener">babel</a></li>
      <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint" target="_blank" rel="noopener">eslint</a></li>
    </ul>
    <h3>Essential Links</h3>
    <ul>
      <li><a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a></li>
      <li><a href="https://chat.vuejs.org" target="_blank" rel="noopener">Community Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a></li>
      <li><a href="https://news.vuejs.org" target="_blank" rel="noopener">News</a></li>
    </ul>
    <h3>Ecosystem</h3>
    <ul>
      <li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
      <li><a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a></li>
      <li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
      <li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
    </ul>
  </div>   
</template>
https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1439597620,2930080928&fm=26&gp=0.jpg

https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1587052655196&di=734f61f9e0d77d521ad86693062d6aae&imgtype=0&src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F01668755407ed20000002b018ce2cd.jpg
https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1587052694436&di=cd792b649d8741dc1655136f5874e3fb&imgtype=0&src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2F30e4372f249b1fcd3e304fc442a181c6ce82161a278e6-LgGvD4_fw658
-->

<template>
    <yd-slider autoplay="3000">
        <!-- <yd-slider-item>
            <a href="http://smskb-forum.qianyiyule.top">
                <img :src="require('@/assets/smskb-discovery-img/smbbs2.png')">
            </a>
        </yd-slider-item> -->
        <yd-slider-item>
            <a href="#">
                <img :src="require('@/assets/smskb-discovery-img/banner-smskb.jpg')">
            </a>
        </yd-slider-item>
        <!-- <yd-slider-item>
            <a href="https://smskb.oss-cn-beijing.aliyuncs.com/wxClear.apk">
                <img :src="require('@/assets/smskb-discovery-img/wxhyql3.jpg')">
            </a>
        </yd-slider-item> -->
    </yd-slider>
</template>

<script>
export default {
  name: "Banner",
  props: {
    msg: String,

    rows:{
      type:Number,
      default:3
    },
    dataItems:{
      type:Array,
      default(){
        return [];
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

img {
  height: 200px;
  border-radius:10px;
}
</style>
